export default "__VITE_ASSET__CSvxONE6__"